export const FAQ_LOADING = "FAQ_LOADING";
export const GET_FAQS = "GET_FAQS";
export const REMOVE_FAQ_DATA = "REMOVE_FAQ_DATA";
